/* ============================================================
   snf-archetype-quiz.js
   Logic for sections/archetype-quiz.liquid ONLY.

   Split out of the section file so that:
     - the .liquid stays small enough to edit reliably
       (it was 29.7KB; theme writes fail around ~22KB)
     - styling lives in assets/snf-archetype-quiz.css
     - logic lives here
   Three files, one job each. Nothing shared, nothing bulk.

   DEPENDS ON these element ids in the section markup - do not rename:
     snfDetails snfName snfDob snfPhone snfDetailsGo snfDetailsSkip
     snfQuiz snfStep snfQ snfOpts snfDots
     snfRitual snfRitEye snfRitTitle snfRitStep
     snfReveal snfSignHero snfSignSym snfSignName snfSignEl snfNumrow
     snfArchIcon snfName2 snfTag snfQuote snfDesc snfPowers
     snfShadow snfShadowIcon snfShadowName snfShadowBody
     snfImg snfPname snfPprice snfBuy snfGrid

   snf-layout-patches.js also reads #snfGrid to correct the Dandy / Siren
   cards. Keep that id.
   ============================================================ */
(function(){
'use strict';
if(!document.getElementById('snfGrid'))return;

function snfPrice(h){ var m = window.SNF_PRICE || {}; return m[h] ? ('from ' + m[h]) : ''; }

var ICONS={
  rake:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 4L9 17l3 13 8 6 8-6 3-13L20 4z"/><path d="M14 20h12M20 14v12" stroke-linecap="round" stroke-opacity=".4"/></svg>',
  idealLover:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="15"/><path d="M20 9v11l6 3" stroke-linecap="round" stroke-opacity=".5"/></svg>',
  star:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="5"/><path d="M20 4v4M20 32v4M4 20h4M32 20h4M8.6 8.6l2.8 2.8M28.6 28.6l2.8 2.8M31.4 8.6l-2.8 2.8M11.4 28.6l-2.8 2.8" stroke-linecap="round"/></svg>',
  natural:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 36V20M20 20C20 12 15 8 8 6c2 6 5 11 12 14M20 20c0-8 5-12 12-14-2 6-5 11-12 14" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  charmer:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="13" r="6"/><path d="M8 34c0-6.6 5.4-12 12-12s12 5.4 12 12" stroke-linecap="round"/></svg>',
  charismatic:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="6"/><path d="M20 4v6M20 30v6M4 20h6M30 20h6M9 9l4 4M27 27l4 4M31 9l-4 4M13 27l-4 4" stroke-linecap="round" stroke-opacity=".7"/></svg>',
  siren:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 4C14 7 11 12 11 18c0 4 2 7 5 9l4 3 4-3c3-2 5-5 5-9 0-6-3-11-9-14z"/><path d="M20 4v26M16 12c2 1 3 2 4 2s2-1 4-2" stroke-linecap="round" stroke-opacity=".4"/></svg>',
  dandy:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 4l3 10h10l-8 6 3 10-8-6-8 6 3-10-8-6h10z"/></svg>',
  coquette:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="6"/><path d="M20 4v6M20 30v6M4 20h6M30 20h6" stroke-linecap="round" stroke-opacity=".5"/></svg>'
};

/* NOTE: siren.img was IMG_0366.png, which DOES NOT EXIST in Shopify Files
   (only 0364, 0365, 0367, 0369-0374 exist). Pointed at IMG_0367.png so the
   Siren no longer shows a broken image. Pre-existing bug, fixed in passing. */
var P={
  rake:{name:"The Rake",tag:"Reckless Devotion",quote:"The Rake offers something rare in a world of caution \u2014 total abandon.",desc:"Your seduction is total, reckless and all-consuming. You offer devotion so complete it becomes addictive.",powers:["Intensity","Devotion","Boldness","Passion","Focus"],img:"IMG_0373.png?v=1773522647",handle:"the-rake"},
  idealLover:{name:"The Ideal Lover",tag:"Mirror of Dreams",quote:"The Ideal Lover exaggerates the positive image that people have of themselves.",desc:"You see what someone most wants to be \u2014 and reflect it back perfectly. You make the ordinary feel like destiny.",powers:["Empathy","Vision","Devotion","Poetry","Fantasy"],img:"IMG_0371.png?v=1773522657",handle:"iconic-oil"},
  star:{name:"The Star",tag:"Transcendent Distance",quote:"The Star does not come to the audience \u2014 the audience orbits the Star, always hoping to be chosen.",desc:"You seduce through absence and elevation. You create a mythology that makes access to you feel like a rare privilege.",powers:["Mystique","Mythology","Rarity","Presence","Grandeur"],img:"IMG_0374.png?v=1773522660",handle:"the-star"},
  natural:{name:"The Natural",tag:"Playful Innocence",quote:"The Natural is in their element \u2014 their ease makes everyone around them feel lighter.",desc:"Your power is disarming honesty. You have the rare ability to be completely yourself \u2014 and that is the most seductive thing of all.",powers:["Authenticity","Playfulness","Trust","Spontaneity","Warmth"],img:"IMG_0372.png?v=1773522657",handle:"caramel-climax"},
  charmer:{name:"The Charmer",tag:"Ego Flattery",quote:"The Charmer understands that people are primarily interested in themselves \u2014 and obliges them gloriously.",desc:"You make everyone feel like the most interesting person in the room. People become addicted to feeling understood.",powers:["Attention","Warmth","Wit","Listening","Generosity"],img:"IMG_0364.png?v=1773522657",handle:"nectar-nymph-oil"},
  charismatic:{name:"The Charismatic",tag:"Radiant Presence",quote:"Charisma is not loud. It is undeniable.",desc:"You seduce through sheer presence \u2014 an energy that fills a room before you say a word. People want to be near you, simply to feel what you feel.",powers:["Magnetism","Confidence","Energy","Warmth","Presence"],img:"IMG_0365.png?v=1773522657",handle:"the-charismatic"},
  siren:{name:"The Siren",tag:"Desire & Danger",quote:"The Siren does not persuade \u2014 she makes herself irresistible, and lets the other do all the work.",desc:"You seduce through atmosphere and an aura of dangerous promise. People cannot explain why they are drawn to you \u2014 only that they are.",powers:["Mystery","Allure","Tension","Presence","Danger"],img:"IMG_0367.png?v=1773522658",handle:"honey-pot"},
  dandy:{name:"The Dandy",tag:"Androgynous Allure",handle:"the-dandy-2"}
};
var SOON={
  coquette:{name:"The Coquette",tag:"Hot & Cold"}
};
var CDN="https://cdn.shopify.com/s/files/1/0926/7606/3571/files/";

var grid=document.getElementById('snfGrid');
["rake","idealLover","star","natural","charmer","charismatic","siren","dandy"].forEach(function(k){
  var p=P[k];var d=document.createElement('a');d.className='snf-card';
  d.href='/products/'+p.handle;
  d.innerHTML='<div class="nm">'+p.name+'</div><div class="ds">'+snfPrice(p.handle)+'</div><div class="tagline">'+p.tag+'</div>';
  grid.appendChild(d);
});
["coquette"].forEach(function(k){
  var s=SOON[k];var d=document.createElement('div');d.className='snf-card soon';
  d.innerHTML='<div class="nm">'+s.name+'</div><div class="ds">Coming soon</div><div class="tagline">'+s.tag+'</div>';
  grid.appendChild(d);
});

function reduceNum(n,keepMaster){
  n=Math.abs(Math.round(n));
  while(n>9){
    if(keepMaster&&(n===11||n===22||n===33))return n;
    n=String(n).split('').reduce(function(a,d){return a+parseInt(d,10);},0);
  }
  return n;
}
function digitSum(s){return (String(s).match(/\d/g)||[]).reduce(function(a,d){return a+parseInt(d,10);},0);}
function lifePathFromDOB(d,m,y){return reduceNum(digitSum(String(d)+String(m)+String(y)),true);}
function expressionFromName(n){
  var sum=n.toUpperCase().replace(/[^A-Z]/g,'').split('').reduce(function(a,c){return a+(c.charCodeAt(0)-64);},0);
  return reduceNum(sum,true);
}
function personalFromPhone(p){return reduceNum(digitSum(p),true);}

var NUM_MEANINGS={
  1:["The Leader"],2:["The Diplomat"],3:["The Expressive"],4:["The Builder"],
  5:["The Free Spirit"],6:["The Nurturer"],7:["The Seeker"],8:["The Powerhouse"],
  9:["The Old Soul"],11:["The Intuitive"],22:["The Architect"],33:["The Healer"]
};
var SIGNS=[
  {name:"Capricorn",sym:"\u2651",from:[12,22],to:[1,19],element:"Earth",planet:"Saturn"},
  {name:"Aquarius",sym:"\u2652",from:[1,20],to:[2,18],element:"Air",planet:"Uranus"},
  {name:"Pisces",sym:"\u2653",from:[2,19],to:[3,20],element:"Water",planet:"Neptune"},
  {name:"Aries",sym:"\u2648",from:[3,21],to:[4,19],element:"Fire",planet:"Mars"},
  {name:"Taurus",sym:"\u2649",from:[4,20],to:[5,20],element:"Earth",planet:"Venus"},
  {name:"Gemini",sym:"\u264A",from:[5,21],to:[6,20],element:"Air",planet:"Mercury"},
  {name:"Cancer",sym:"\u264B",from:[6,21],to:[7,22],element:"Water",planet:"Moon"},
  {name:"Leo",sym:"\u264C",from:[7,23],to:[8,22],element:"Fire",planet:"Sun"},
  {name:"Virgo",sym:"\u264D",from:[8,23],to:[9,22],element:"Earth",planet:"Mercury"},
  {name:"Libra",sym:"\u264E",from:[9,23],to:[10,22],element:"Air",planet:"Venus"},
  {name:"Scorpio",sym:"\u264F",from:[10,23],to:[11,21],element:"Water",planet:"Pluto"},
  {name:"Sagittarius",sym:"\u2650",from:[11,22],to:[12,21],element:"Fire",planet:"Jupiter"}
];
function zodiacFromDOB(month,day){
  for(var i=0;i<SIGNS.length;i++){
    var s=SIGNS[i],f=s.from,t=s.to;
    if(f[0]===t[0]){if(month===f[0]&&day>=f[1]&&day<=t[1])return s;}
    else{if(month===f[0]&&day>=f[1])return s;if(month===t[0]&&day<=t[1])return s;}
  }
  return SIGNS[0];
}

var profileData={};
var QUESTIONS=[
  {q:"When you walk into a room, you...",opts:[
    {t:"Make people come to you, without trying",a:"natural"},
    {t:"Already have every eye on you",a:"star"},
    {t:"Scan for who is interesting, then vanish before they expect it",a:"rake"},
    {t:"Find the one person you want, and only them",a:"idealLover"}
  ]},
  {q:"Your idea of seduction is...",opts:[
    {t:"Wit, charm, a perfectly timed line",a:"charmer"},
    {t:"A presence so magnetic, people just orbit you",a:"charismatic"},
    {t:"Making someone feel like the only person ever truly seen",a:"idealLover"},
    {t:"Leaving before the spell breaks",a:"rake"}
  ]},
  {q:"People remember you for...",opts:[
    {t:"How you made them feel, not what you said",a:"natural"},
    {t:"Being almost mythic, unforgettable",a:"star"},
    {t:"Noticing everything about them",a:"idealLover"},
    {t:"Something sweeter, harder to resist",a:"siren"}
  ]},
  {q:"If you disappeared tonight, people would...",opts:[
    {t:"Talk about you for weeks",a:"charismatic"},
    {t:"Wonder if you were ever really there",a:"rake"},
    {t:"Already be planning how to see you again",a:"charmer"},
    {t:"Miss the warmth more than the chase",a:"natural"}
  ]}
];
var current=0,answers=[];
var quizEl=document.getElementById('snfQuiz');
var revealEl=document.getElementById('snfReveal');
var ritualEl=document.getElementById('snfRitual');

function startQuiz(){
  var name=document.getElementById('snfName').value.trim();
  var dob=document.getElementById('snfDob').value;
  var phone=document.getElementById('snfPhone').value.trim();
  profileData={};
  if(name)profileData.expression=expressionFromName(name);
  if(dob){
    var p=dob.split('-');
    var y=parseInt(p[0],10),m=parseInt(p[1],10),d=parseInt(p[2],10);
    profileData.lifePath=lifePathFromDOB(d,m,y);
    profileData.zodiac=zodiacFromDOB(m,d);
  }
  if(phone)profileData.personal=personalFromPhone(phone);
  document.getElementById('snfDetails').style.display='none';
  quizEl.style.display='block';
  renderQuestion();
}
document.getElementById('snfDetailsGo').onclick=startQuiz;
document.getElementById('snfDetailsSkip').onclick=startQuiz;

function renderQuestion(){
  quizEl.style.display='block';
  revealEl.classList.remove('show');
  ritualEl.classList.remove('show');
  var step=QUESTIONS[current];
  document.getElementById('snfStep').textContent='Step 2 of 2 \u2014 Question '+(current+1)+' of '+QUESTIONS.length;
  document.getElementById('snfQ').textContent=step.q;
  var optsEl=document.getElementById('snfOpts');optsEl.innerHTML='';
  step.opts.forEach(function(o){
    var b=document.createElement('button');
    b.className='snf-opt';b.textContent=o.t;b.type='button';
    b.onclick=function(){answers.push(o.a);current++;if(current<QUESTIONS.length){renderQuestion();}else{runRitual();}};
    optsEl.appendChild(b);
  });
  var dots=document.getElementById('snfDots');dots.innerHTML='';
  QUESTIONS.forEach(function(_,i){
    var d=document.createElement('div');d.className='snf-dot'+(i<=current?' on':'');
    dots.appendChild(d);
  });
}

function runRitual(){
  quizEl.style.display='none';
  ritualEl.classList.add('show');
  var steps=[
    {e:'\u2605',t:'Reading the stars',s:'Locating your birth chart...'},
    {e:'\u2726',t:'Calculating your numbers',s:''},
    {e:'\u263D',t:'Consulting the planets',s:''},
    {e:'\u25C8',t:'Mapping your archetype',s:''},
    {e:'\u2726',t:'Your profile is complete',s:'Revealing your true nature...'}
  ];
  var i=0;
  (function step(){
    if(i>=steps.length){ritualEl.classList.remove('show');reveal();return;}
    var st=steps[i];
    document.getElementById('snfRitEye').textContent=st.e;
    document.getElementById('snfRitTitle').textContent=st.t;
    var s=st.s;
    if(i===1&&(profileData.lifePath||profileData.expression))
      s='Life path '+(profileData.lifePath||'\u2014')+' \u00B7 Expression '+(profileData.expression||'\u2014');
    if(i===2&&profileData.zodiac)
      s=profileData.zodiac.name+' \u00B7 '+profileData.zodiac.element+' \u00B7 '+profileData.zodiac.planet;
    document.getElementById('snfRitStep').textContent=s;
    i++;
    setTimeout(step,i===steps.length?700:650);
  })();
}

function numCell(num,lbl){
  var m=NUM_MEANINGS[num]||[""];
  return '<div class="snf-numcell"><div class="num">'+num+'</div><div class="lbl">'+lbl+'</div><div class="nm">'+m[0]+'</div></div>';
}

function reveal(){
  var tally={};answers.forEach(function(a){tally[a]=(tally[a]||0)+1;});
  var sorted=Object.keys(tally).sort(function(a,b){return tally[b]-tally[a];});
  var best=sorted[0],shadow=sorted[1];
  var p=P[best];

  var signHero=document.getElementById('snfSignHero');
  if(profileData.zodiac){
    var z=profileData.zodiac;
    document.getElementById('snfSignSym').textContent=z.sym;
    document.getElementById('snfSignName').textContent=z.name;
    document.getElementById('snfSignEl').textContent=z.element+' \u00B7 ruled by '+z.planet;
    signHero.style.display='block';
  }else{signHero.style.display='none';}

  var numrow=document.getElementById('snfNumrow');
  var cells='';
  if(profileData.lifePath)cells+=numCell(profileData.lifePath,'Life Path');
  if(profileData.expression)cells+=numCell(profileData.expression,'Expression');
  if(profileData.personal)cells+=numCell(profileData.personal,'Personal');
  if(cells){numrow.innerHTML=cells;numrow.style.display='grid';}else{numrow.style.display='none';}

  document.getElementById('snfArchIcon').innerHTML=ICONS[best]||'';
  document.getElementById('snfName2').textContent=p.name;
  document.getElementById('snfTag').textContent=p.tag;
  document.getElementById('snfQuote').textContent=p.quote;
  document.getElementById('snfDesc').textContent=p.desc;
  document.getElementById('snfPowers').innerHTML=p.powers.map(function(x){return '<span class="snf-power">'+x+'</span>';}).join('');

  var shadowEl=document.getElementById('snfShadow');
  if(shadow&&P[shadow]){
    var sp=P[shadow];
    document.getElementById('snfShadowIcon').innerHTML=ICONS[shadow]||'';
    document.getElementById('snfShadowName').textContent=sp.name;
    document.getElementById('snfShadowBody').textContent=sp.desc;
    shadowEl.style.display='flex';
  }else{shadowEl.style.display='none';}

  document.getElementById('snfImg').src=CDN+p.img;
  document.getElementById('snfPname').textContent=p.name+' \u00B7 10ml Roller';
  document.getElementById('snfPprice').textContent=snfPrice(p.handle);
  document.getElementById('snfBuy').href='/products/'+p.handle;

  revealEl.classList.add('show');
}

window.snfRestart=function(){
  current=0;answers=[];profileData={};
  document.getElementById('snfName').value='';
  document.getElementById('snfDob').value='';
  document.getElementById('snfPhone').value='';
  revealEl.classList.remove('show');
  ritualEl.classList.remove('show');
  quizEl.style.display='none';
  document.getElementById('snfDetails').style.display='block';
};

})();
